import * as React from "react";
import { FieldInputProps, FieldMetaProps, FieldHelperProps } from "formik";

// Types
import Answer from "../../types/Answer.interface";

// Misc.
import { useConditionDispatch } from "../../context/Condition.context";

interface RadioElement {
  answer: Answer;
  field: FieldInputProps<any>;
  meta: FieldMetaProps<any>;
  helper: FieldHelperProps<any>;
  value: string;
  statementId: string;
}

const RadioElement: React.FC<RadioElement> = (props: RadioElement) => {
  const { answer, field, meta, helper, value, statementId } = props;
  const condDispatch = useConditionDispatch();

  return (
    <input
      className="mr-2 input-radio__element"
      id={answer._id}
      type="radio"
      {...field}
      value={value}
      checked={meta.value.id === answer._id}
      onChange={() => {
        helper.setValue({ id: answer._id, value });
        condDispatch({
          type: "add",
          payload: { [statementId]: { id: answer._id, value } },
        });

        // helper.setTouched(true);
      }}
    />
  );
};

export default RadioElement;
